import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { FaqsConfig } from '../../constants/faqs/FaqsConfig';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import ProductInfoContainer from '../common/ProductInfoContainer';
import Faq from '../faqs/Faq';
import FooterMicrocopy from '../faqs/FooterMicrocopy';
import Question from '../faqs/Question';
import HeaderLayout from '../layout/HeaderLayout';
import ProductPageSubtitle from './ProductPageSubtitle';
import ProductPageTitle, { ProductPageHeader } from './ProductPageTitle';
import { fetchPaymentsAccountEligibility } from 'growth-payments-core/api/eligibility';
import CaseStudies from 'pricing-pages-ui/components/case-studies/CaseStudies';
import { useSelector } from 'react-redux';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { NavItemEnum } from '../../constants/routing/NavItems';
import Screens from '../../constants/routing/Screens';
import { ENTERPRISE, STARTER } from '../../constants/routing/Tabs';
import { useIsMobile } from '../../context/IsMobileContext';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { isInUnitedStatesSelector } from '../../selectors/CountrySelectors';
import { hasPricingAndPurchasingFailedSelector } from '../../selectors/LoadingStateSelectors';
import BannerSection from '../banners/BannerSection';
import PaymentsProcessorsWrapper from '../commerce-hub/PaymentsProcessorsWrapper';
import BringCommerceCtaCard from '../commerce/BringCommerceCtaCard';
import FailedLoadBanner from '../common/loading/FailedLoadBanner';
import FallbackErrorBanner from '../common/loading/FallbackErrorBanner';
import CompanyProof from '../company-proof/CompanyProof';
import CommerceFeatureTableContainer from '../feature-table/CommerceFeatureTableContainer';
import MobileWrapperNoTabs from '../mobile/containers/MobileWrapperNoTabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommercePage = () => {
  const pageName = NavItemEnum.COMMERCE;
  useDocumentTitle(pageName);
  const isMobile = useIsMobile();
  const isAppAuth = useSelector(isAppAuthSelector);
  const isUnitedStates = useAppSelector(isInUnitedStatesSelector);
  const navMarkerName = `${pageName.toUpperCase()}_PAGE`;
  const [eligibility, setEligibility] = useState();
  const hasPricingAndPurchasingFailed = useAppSelector(hasPricingAndPurchasingFailedSelector);
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: pageName
    });
  }, [pageName]);
  useEffect(() => {
    if (isAppAuth) {
      fetchPaymentsAccountEligibility().then(setEligibility).catch(err => Raven.captureException(new Error('Payments account eligibility check failed'), {
        extra: {
          error: err
        }
      }));
    }
  }, [isAppAuth]);
  const PageWrapper = ({
    children
  }) => {
    if (isMobile) {
      return /*#__PURE__*/_jsx(MobileWrapperNoTabs, {
        navMarkerName: navMarkerName,
        navItem: NavItemEnum.COMMERCE,
        children: children
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName
      }), /*#__PURE__*/_jsx(HeaderLayout, {
        selectedNavItem: pageName,
        children: /*#__PURE__*/_jsx(ProductInfoContainer, {
          children: children
        })
      })]
    });
  };
  return /*#__PURE__*/_jsxs(PageWrapper, {
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: Screens.COMMERCE
    }), /*#__PURE__*/_jsx(FailedLoadBanner, {
      hasFailed: hasPricingAndPurchasingFailed
    }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(ProductPageHeader, {
      children: [/*#__PURE__*/_jsx(ProductPageTitle, {
        productLine: COMMERCE
      }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
        productLine: COMMERCE
      })]
    }), /*#__PURE__*/_jsx("section", {
      style: {
        marginTop: '15px'
      },
      children: /*#__PURE__*/_jsx(BringCommerceCtaCard, {})
    }), /*#__PURE__*/_jsx(PaymentsProcessorsWrapper, {
      isUnitedStates: isUnitedStates,
      paymentsAccountEligibility: eligibility
    }), /*#__PURE__*/_jsx(CommerceFeatureTableContainer, {}), /*#__PURE__*/_jsx(CompanyProof, {
      tab: ENTERPRISE,
      screen: Screens.COMMERCE
    }), /*#__PURE__*/_jsx(CaseStudies, {
      productLine: COMMERCE,
      tab: STARTER
    }), /*#__PURE__*/_jsxs(Faq, {
      children: [FaqsConfig[pageName.toLowerCase()].map(_ref => {
        let {
            questionKey
          } = _ref,
          passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
        return /*#__PURE__*/_jsx(Question, Object.assign({
          questionKey: questionKey
        }, passthroughOptions), questionKey);
      }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
    })]
  });
};
export default CommercePage;